let state = null;
let settled = false;
let resolveReady;
const ready = new Promise(resolve => {
  resolveReady = resolve;
});

const SAFETY_TIMEOUT_MS = 4000;
setTimeout(() => markBuyerSettled(), SAFETY_TIMEOUT_MS);

export function setBuyer(buyer) {
  state = buyer && buyer.customerAccessToken ? buyer : null;
  if (!settled) {
    settled = true;
    resolveReady(state);
  }
}

export function clearBuyer() {
  state = null;
}

export function markBuyerSettled() {
  if (settled) return;
  settled = true;
  resolveReady(null);
}

export function getBuyer() {
  return state;
}

export function isBuyerSettled() {
  return settled;
}

export function whenBuyerReady() {
  return ready;
}
